import Head from 'next/head';
import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useRouter } from 'next/router';
import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import mixpanel from 'mixpanel-browser';

import { logAuthenticationRequired } from '../utils/authLib';
import { useUser } from '../utils/users';
import Gallery from "../components/Gallery";
import GalleryTabSelector from '../components/GalleryTabSelector';
import { AppContext } from '../components/AppState';

function Home(props) {
  const router = useRouter();
  const { isAuthenticated, user } = useAuth0();
  const {
    isAccountLoaded,
    qaDisplay,
    galleryUser, setGalleryUser,
    redirect, setRedirect,
    welcomeFrom, setWelcomeFrom,
    welcomeSkipped,
   } = useContext(AppContext);
  const [queryChecked, setQueryChecked] = useState(false);

  const { userItem } = useUser();
  const { userItem: galleryUserItem } = useUser(galleryUser);

  useEffect(() => {
    mixpanel.track('View Gallery');
  }, []);

  if (!queryChecked && router.isReady && isAuthenticated && isAccountLoaded) {
    // Handle direct gallery user URL, if set
    let uid = router.query['u'];
    if (uid) {
      uid = uid.replace('_', '|');
      setGalleryUser(uid);
    }
    setQueryChecked(true);
  }

  useEffect(() => {
    if (
      router?.isReady &&
      userItem &&
      galleryUser &&
      queryChecked &&
      galleryUser === userItem.userId &&
      !redirect &&
      !welcomeFrom &&
      !welcomeSkipped && (
        !userItem?.onboarding ||
        !userItem?.onboarding?.complete
      )
    ) {
      setWelcomeFrom(router.asPath);
      setRedirect('/welcome');
    }
  }, [router?.isReady, router.asPath, userItem, welcomeSkipped, setWelcomeFrom, setRedirect, redirect, welcomeFrom, galleryUser, queryChecked]);

  useEffect(() => {
    // Wait for router.isReady before accessing router.query (otherwise the query parameters are not yet set)
    if (!galleryUser || !router.isReady) {
      return;
    }

    // Add context for user to the in-browser URL
    let currentUrlParams = new URLSearchParams(window.location.search);
    const oldQueryString = currentUrlParams.toString();
    if (user.sub !== galleryUser) {
      currentUrlParams.set('u', galleryUser.replace('|', '_'));
    } else {
      currentUrlParams.delete('u');
    }
    const newQueryString = currentUrlParams.toString();
    if (newQueryString !== oldQueryString) {
      if (newQueryString.length > 0) {
        router.replace(window.location.pathname + '?' + newQueryString);
      } else {
        router.replace(window.location.pathname);
      }
    }
  }, [galleryUser, router, router.isReady, router.query.u, user.sub]);

  return (
    <>
      <Head>
        <title>
          Bandicoot - App - Library
          {qaDisplay && galleryUserItem?.email ? ` - ${galleryUserItem.email}` : ''}
        </title>
      </Head>
      <GalleryTabSelector current='home' />
      <Gallery />
    </>
  );
}

export default withAuthenticationRequired(
  Home,
  { onBeforeAuthentication: () => { logAuthenticationRequired('Home') } }
);
